import { useEffect, useRef } from 'react';

const useTimeout = (callback: (value: boolean) => void, delayMs: number | null) => {
  const callbackRef = useRef(callback);

  // Update callback ref with separate effect to avoid restarting the timeout
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delayMs == null) {
      return;
    }

    const timeout = setTimeout(() => callbackRef.current(false), delayMs);
    return () => clearTimeout(timeout);
  }, [delayMs]);
};

export default useTimeout;
